/* Marca de un tercero (OpenAI, Claude Code) en tamaño discreto.
 *
 * Los assets se importan por el build, igual que el logo PASCOM: así obtienen una URL con hash de
 * contenido, que ninguna caché ni service worker puede servir desactualizada. Se usan PNG con fondo
 * transparente, rasterizados fielmente desde los SVG originales (que quedan en /brand como fuente),
 * porque esos SVG no declaran `width`/`height` y sin tamaño intrínseco no se pintan de forma fiable.
 *
 * Nunca se dibuja, recrea ni aproxima un logotipo; solo se cambia de formato conservando el trazo.
 * Ambas dimensiones van fijadas y derivadas de la proporción real del lienzo: no hay deformación. */
import { useState } from 'react';

import openaiPng from '/brand/openai-logomark.png?url';
import claudeCodePng from '/brand/claude-code-logomark.png?url';

export const BRAND_ASSETS = { openai: openaiPng, claudeCode: claudeCodePng } as const;

export function BrandMark({ src, name, height = 18, ratio = 1, inline = false }: { src: string; name: string; height?: number; ratio?: number; inline?: boolean }) {
  const [ok, setOk] = useState(true);
  if (!ok) return null;
  const width = Math.round(height * ratio);
  return (
    <img
      src={src}
      alt={name}
      width={width}
      height={height}
      style={{ width, height, display: inline ? 'inline-block' : 'block', verticalAlign: inline ? '-0.15em' : undefined, flex: '0 0 auto' }}
      onError={() => setOk(false)}
      decoding="async"
    />
  );
}
